export class CancellationToken {
    private _isAborted: boolean;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private _abortReason: any;

    constructor() {
        this._isAborted = false;
        this._abortReason = undefined;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public get abortReason(): any {
        return this._abortReason;
    }

    public isAborted(): boolean {
        return this._isAborted;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public abort(reason?: any) {
        this._isAborted = true;
        this._abortReason = reason;
    }

    public reset(): void {
        this._isAborted = false;
        this._abortReason = undefined;
    }
}
